/*
 * *****************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Tue, Aug 17th 2021, 2:38:25 pm
 *
 * *****************************************************
 */

export const HELP_CENTER_LINK = 'https://intercom.help/wiseio/en/';
export const CONTACT_US_LINK = 'mailto:support@wiseio.net?subject=WiseIO Support Request';
export const TERMS_OF_USE_LINK = 'https://wiseio.net/pages/terms-of-service';
export const PRIVACY_POLICY_LINK = 'https://wiseio.net/pages/privacy-policy';
